import { PLATFORM_VERSION_V2 } from "constants/platform";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";

export const useIsGroupV2Platform = (): boolean => {
  const { platform_version } = useCurrentGroupContext();

  return platform_version === PLATFORM_VERSION_V2;
};
